import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../../../../constants/common'
import { formValidationSchemaNoChanged } from '../../../../../Form'

import {
  LISTING_EDIT_TITLE_FIELD_MAX_LENGTH,
  LISTING_EDIT_TITLE_FIELD_NAME,
} from './ListingEditTitleModal.constants'

export function getListingEditTitleInitialValues(title) {
  return {
    [LISTING_EDIT_TITLE_FIELD_NAME]: title || EMPTY_STRING,
  }
}

export function getListingEditTitleValidationSchema({ initialValues, t }) {
  return Yup.object({
    [LISTING_EDIT_TITLE_FIELD_NAME]: Yup.string()
      .trim()
      .required(true)
      .max(
        LISTING_EDIT_TITLE_FIELD_MAX_LENGTH,
        t('Error.MaxLengthKey', { length: LISTING_EDIT_TITLE_FIELD_MAX_LENGTH })
      ),
  }).concat(formValidationSchemaNoChanged({ initialValues }))
}
